import i18n from "@/plugins/i18n"

export default {
  install(app) {
    app.config.globalProperties.$translate = function (key, params = null) {
      return i18n.global.t(key, params)
    }

    app.config.globalProperties.$translatePlural = function (key, value, params = null) {
      return i18n.global.tc(key, value, params)
    }
  }
}
